module.exports = __webpack_public_path__ + "img/ren2.59975392.png";